//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Button} from '@material-ui/core';
import {Add} from '@material-ui/icons';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import {colors} from '../../../../../assets/styles/colors';

// import InformationBlockItem from './InformationBlockItem';
import {
  useStoreInformationBlocks,
  useStoreInformationBlockActions,
} from '../../../utils/information-block';

import type {StoreInformationBlock} from '../../../../../entities/store-information-block';
import StoreInformationBlockItem from './InformationBlockItem';
import {useHomePageLayoutActions} from '../../../../page-layout/utils/home-page';

const useStyles = makeStyles(theme => ({
  addBannerButton: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: colors.grey500,
    border: `2px dashed ${colors.grey500}`,
    borderRadius: '.75rem',
    paddingBlock: '.85rem',
  },
  bannerList: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      borderBottom: `1px solid ${colors.grey300}`,
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
  caption: {
    color: colors.grey500,
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '1rem',
    display: 'block',
  },
}));

type Props = {
  sectionEnabled?: boolean,
  informationBlock?: StoreInformationBlock,
};

export default function InformationBlock(props: Props) {
  const {sectionEnabled, informationBlock} = props;

  const classes = useStyles();

  const {removeSection} = useHomePageLayoutActions();

  const {
    loading,
    informationBlocks,
    refreshBlocks,
  } = useStoreInformationBlocks();
  const {
    deleteStoreInformationBlock,
    updateStoreInformationBlock,
    loading: updating,
  } = useStoreInformationBlockActions();

  const emptyContent = !(
    informationBlocks.length > 0 && informationBlocks.some(p => p.enabled)
  );

  return (
    <SwitchableSection
      title="Sección Informacional"
      subtitle="Selecciona el tipo de sección informacional que desees y llena la información"
      id={HOME_PAGE_SECTION_NAMES.STORE_LOCATION}
      classes={{
        root: (emptyContent || !sectionEnabled) && classes.disabledRoot,
      }}
      loading={loading || updating}
    >
      {!informationBlock && (
        <Button
          fullWidth
          className={classes.addBannerButton}
          component={Link}
          to="/my-store/pages/home-page/information-block/new"
        >
          <Add />
          Agregar Sección
        </Button>
      )}

      {informationBlock && (
        <div className={classes.bannerList}>
          <StoreInformationBlockItem
            informationBlock={informationBlock}
            onDelete={() => {
              deleteStoreInformationBlock(
                informationBlock.storeInformationBlockId
              ).then(() => {
                removeSection(
                  HOME_PAGE_SECTION_NAMES.STORE_INFORMATION_BLOCK,
                  informationBlock.storeInformationBlockId
                );
              });
            }}
            onToggleEnabled={() => {
              updateStoreInformationBlock(
                informationBlock.storeInformationBlockId,
                {
                  enabled: !informationBlock.enabled,
                }
              ).then(() => {
                refreshBlocks();
              });
            }}
          />
        </div>
      )}
    </SwitchableSection>
  );
}
